export default function toLiteralValueOrNull<T extends readonly string[]>(
  values: T,
  value: unknown
): T[number] | null {
  const found = values.find(v => v === value)
  return found ?? null
}
